import React from "react";

/**
 * Segmented Daily / Monthly (or similar) toggle for chart toolbars.
 */
const ChartViewToggle = ({ leftLabel, rightLabel, isRightActive, onChange }) => (
  <div className="segmented-toggle" role="group" aria-label={`${leftLabel} or ${rightLabel}`}>
    <button
      type="button"
      className={`segmented-toggle__btn ${!isRightActive ? "active" : ""}`}
      onClick={() => onChange(false)}
    >
      {leftLabel}
    </button>
    <button
      type="button"
      className={`segmented-toggle__btn ${isRightActive ? "active" : ""}`}
      onClick={() => onChange(true)}
    >
      {rightLabel}
    </button>
  </div>
);

export default ChartViewToggle;
